/* eslint react/jsx-boolean-value: 0 */

import React, { Fragment } from 'react'
import Loadable from 'react-loadable'
import { Redirect, Route } from 'react-router-dom'
import { Switch } from 'sb-react-router'
import { constants, getAbValue, links } from 'common/helpers'

import { Loader } from 'components/_new/ui'
import App from 'containers/App/App'
import HasAuth from 'containers/HasAuth/HasAuth'
import Page404 from 'pages/404/404' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/500/500' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/seo/BrandsPage/BrandsPage' // DON'T REMOVE THIS! THIS IS FOR SSR! // TODO remove with ft brandPage - added 17/06/2020 by @mikediam
import 'pages/seo/CommonPage/CommonPage' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/seo/NotePage/NotePage' // DON'T REMOVE THIS! THIS IS FOR SSR!
import CheckHelmet from 'pages/CheckHelmet/CheckHelmet'


const loading = Loader


// Layouts

const InsideLayout                    = Loadable({ loader: () => import('layouts/InsideLayout/InsideLayout'), loading })
const HumbleLayout                    = Loadable({ loader: () => import('layouts/HumbleLayout/HumbleLayout'), loading })
const LandingLayout                   = Loadable({ loader: () => import('layouts/LandingLayout/LandingLayout'), loading })
const SubscriptionLayout              = Loadable({ loader: () => import('layouts/SubscriptionLayout/SubscriptionLayout'), loading })
const ProfileLayout                   = Loadable({ loader: () => import('layouts/ProfileLayout/ProfileLayout'), loading })
const UserProfileLayout               = Loadable({ loader: () => import('layouts/UserProfileLayout/UserProfileLayout'), loading })
const WithoutHeaderLayout             = Loadable({ loader: () => import('layouts/WithoutHeaderLayout/WithoutHeaderLayout'), loading })


// Pages


const WithMiragePage                  = Loadable({ loader: () => import('pages/WithMiragePage/WithMiragePage'), loading })
const NoMatch                         = Loadable({ loader: () => import('pages/NoMatch/NoMatch'), loading })

// promo
const TossInPage                      = Loadable({ loader: () => import('pages/TossInPage/TossInPage'), loading })
const OldBuyQueuePage                 = Loadable({ loader: () => import('pages/BuyQueuePage/BuyQueuePage'), loading })
const RecurlyBuyQueuePage             = Loadable({ loader: () => import('pages/BuyQueuePageRecurly/BuyQueuePage'), loading })

// pick your scent
const PickPage                        = Loadable({ loader: () => import('pages/PickPage/PickPage'), loading })

// Landings
const RootPage                        = Loadable({ loader: () => import('pages/landings/RootPage/RootPage'), loading })
const MixPage                         = Loadable({ loader: () => import('pages/landings/mix/DefaultView/DefaultView'), loading })
const PopupShopPage                   = Loadable({ loader: () => import('pages/landings/PopupShopPage/PopupShopPage'), loading })
const NewMaleMixPage                  = Loadable({ loader: () => import('pages/landings/mix/new/NewMaleMixPage/NewMaleMixPage'), loading })
const NewFemaleMixPage                = Loadable({ loader: () => import('pages/landings/mix/new/NewFemaleMixPage/NewFemaleMixPage'), loading })
const SkincareIntroPage               = Loadable({ loader: () => import('pages/landings/SkincareIntroPage/SkincareIntroPage'), loading })
const ReferralLandingPage             = Loadable({ loader: () => import('pages/landings/ReferralLandingPage/ReferralLandingPage'), loading })
const FreeTrialPage                   = Loadable({ loader: () => import('pages/landings/FreeTrialPage/FreeTrialPage'), loading })
const EmailLandingPage                = Loadable({ loader: () => import('pages/landings/emailTemplate/EmailLandingPage'), loading })
const EmailQuizPickPage               = Loadable({ loader: () => import('pages/landings/emailTemplate/EmailQuizPickPage/EmailQuizPickPage'), loading })

// plan
const PlanPage                        = Loadable({ loader: () => import('pages/PlanPage/PlanPage'), loading })

// payment
const OldSubscribePage                = Loadable({ loader: () => import('pages/payment/SubscribePageConductor'), loading })
const OldPaymentPage                  = Loadable({ loader: () => import('pages/payment/PaymentPage/PaymentPage'), loading })
const OldGiftCardPaymentPage          = Loadable({ loader: () => import('pages/payment/GiftCardPaymentPage/GiftCardPaymentPage'), loading })
const OldGiftSubscriptionPaymentPage  = Loadable({ loader: () => import('pages/payment/GiftSubscriptionPaymentPage/GiftSubscriptionPaymentPage'), loading })
const OldGiftSubscriptionRedeemPage   = Loadable({ loader: () => import('pages/payment/GiftSubscriptionRedeemPage/GiftSubscriptionRedeemPage'), loading })
const OldRedeemCouponPage             = Loadable({ loader: () => import('pages/payment/RedeemCouponPage/RedeemCouponPage'), loading })
const OldThankYouPage                 = Loadable({ loader: () => import('pages/ThankYouPage/ThankYouPage'), loading })

// new payment
const OldRedeemQueuePage              = Loadable({ loader: () => import('pages/paymentNew/RedeemQueuePage/RedeemQueuePage'), loading })
const RecurlyRedeemQueuePage          = Loadable({ loader: () => import('pages/paymentRecurly/RedeemQueuePage/RedeemQueuePage'), loading })
const RedeemTossInPage                = Loadable({ loader: () => import('pages/paymentNew/RedeemTossInPage/RedeemTossInPage'), loading })
const SubscribePrototypePage          = Loadable({ loader: () => import('pages/paymentNew/SubscribePrototypePage/SubscribePrototypePage'), loading })

// recurly payment
const RecurlySubscribePage                = Loadable({ loader: () => import('pages/paymentRecurly/SubscribePage/SubscribePage'), loading })
const RecurlyEcommercePage                = Loadable({ loader: () => import('pages/paymentRecurly/EcommercePage/EcommercePage'), loading })
const RecurlyGiftCardPaymentPage          = Loadable({ loader: () => import('pages/paymentRecurly/GiftCardPaymentPage/GiftCardPaymentPage'), loading })
const RecurlyGiftSubscriptionPaymentPage  = Loadable({ loader: () => import('pages/paymentRecurly/GiftSubscriptionPaymentPage/GiftSubscriptionPaymentPage'), loading })
const RecurlyGiftSubscriptionRedeemPage   = Loadable({ loader: () => import('pages/paymentRecurly/GiftSubscriptionRedeemPage/GiftSubscriptionRedeemPage'), loading })
const RecurlyRedeemCouponPage             = Loadable({ loader: () => import('pages/paymentRecurly/RedeemCouponPage/RedeemCouponPage'), loading })
const RecurlyThankYouPage                 = Loadable({ loader: () => import('pages/paymentRecurly/ThankYouPage/ThankYouPage'), loading })

const RecurlyCardUpdatePage               = Loadable({ loader: () => import('pages/paymentRecurly/CardUpdatePage/CardUpdatePage'), loading })

// products
const ProductsPage                    = Loadable({ loader: () => import('pages/ProductsPage/ProductsPage'), loading })
const CosmeticsProductsPage           = Loadable({ loader: () => import('pages/CosmeticsProductsPage/CosmeticsProductsPage'), loading })
const HowHandCreamsWorkPage           = Loadable({ loader: () => import('pages/howItWorksPages/HowHandCreamsWorkPage/HowHandCreamsWorkPage'), loading })
const HowItWorksPage                  = Loadable({ loader: () => import('pages/howItWorksPages/HowItWorksPage/HowItWorksPage'), loading })
const ProductPage                     = Loadable({ loader: () => import('pages/ProductPage/ProductPage'), loading })

// profile
const ReceivedProductsPage            = Loadable({ loader: () => import('pages/profile/ReceivedProductsPage/ReceivedProductsPage'), loading })
const ProductsInQueuePage             = Loadable({ loader: () => import('pages/profile/ProductsInQueuePage/ProductsInQueuePage'), loading })
const SubscriptionStatusPage          = Loadable({ loader: () => import('pages/profile/SubscriptionStatusPage/SubscriptionStatusPage'), loading })
const OrderHistoryPagePage            = Loadable({ loader: () => import('pages/profile/OrderHistoryPage/OrderHistoryPage'), loading })
const EcommerceOrderPage              = Loadable({ loader: () => import('pages/profile/EcommerceOrderPage/EcommerceOrderPage'), loading })
const ChangePasswordPage              = Loadable({ loader: () => import('pages/profile/ChangePasswordPage/ChangePasswordPage'), loading })
const PersonalPage                    = Loadable({ loader: () => import('pages/profile/PersonalPage/PersonalPage'), loading })
const BillingAndShippingPage          = Loadable({ loader: () => import('pages/profile/BillingAndShippingPage/BillingAndShippingPage'), loading })
const SentGiftsPage                   = Loadable({ loader: () => import('pages/profile/SentGiftsPage/SentGiftsPage'), loading })
const ReviewsPage                     = Loadable({ loader: () => import('pages/profile/ReviewsPage/ReviewsPage'), loading })
const RatedProductsPage               = Loadable({ loader: () => import('pages/profile/RatedProductsPage/RatedProductsPage'), loading })

const UserProfileRatedProductsPage    = Loadable({ loader: () => import('pages/profile/UserProfileRatedProductsPage/UserProfileRatedProductsPage'), loading })
const UserProfileReviewsPage          = Loadable({ loader: () => import('pages/profile/UserProfileReviewsPage/UserProfileReviewsPage'), loading })

// subscription
const UnpausePage                     = Loadable({ loader: () => import('pages/UnpausePage/UnpausePage'), loading })
const ResubscribeOldPage              = Loadable({ loader: () => import('pages/resubscribe/ResubscribeOldPage/ResubscribeOldPage'), loading })
const Resubscribe50Page               = Loadable({ loader: () => import('pages/resubscribe/Resubscribe50Page/Resubscribe50Page'), loading })
const MultiOfferResubscribePage       = Loadable({ loader: () => import('pages/resubscribe/MultiOfferResubscribePage/MultiOfferResubscribePage'), loading })
const ResubscribeFreeProductPage      = Loadable({ loader: () => import('pages/resubscribe/ResubscribeFreeProductPage/ResubscribeFreeProductPage'), loading })
const CancelSubscriptionPage          = Loadable({ loader: () => import('pages/CancelSubscriptionPage/CancelSubscriptionPage'), loading })

// card update
const CardUpdatePage                  = Loadable({ loader: () => import('pages/cardUpdate/CardUpdatePage/CardUpdatePage'), loading })
const CaseCardUpdatePage              = Loadable({ loader: () => import('pages/cardUpdate/CaseCardUpdatePage/CaseCardUpdatePage'), loading })
const CardUpdatePageNew               = Loadable({ loader: () => import('pages/cardUpdate/CardUpdatePageNew/CardUpdatePageNew'), loading })

// blogger
const BloggerPage                     = Loadable({ loader: () => import('pages/BloggerPage/BloggerPage'), loading })

// brands
const BrandsPage                      = Loadable({ loader: () => import('pages/BrandsPage/BrandsPage'), loading })
const BrandPageOld                    = Loadable({ loader: () => import('pages/BrandPageOld/BrandPageOld'), loading })
const BrandSkeletonPage               = Loadable({ loader: () => import('pages/BrandSkeletonPage/BrandSkeletonPage'), loading })
const BrandPage                       = Loadable({ loader: () => import('pages/BrandPage/BrandPage'), loading: BrandSkeletonPage })

// common
const DowngradePage                   = Loadable({ loader: () => import('pages/DowngradePage/DowngradePage'), loading })
const UpgradePage                     = Loadable({ loader: () => import('pages/upgrade/UpgradePage/UpgradePage'), loading })
const UpgradeProductPage              = Loadable({ loader: () => import('pages/upgrade/UpgradeProductPage/UpgradeProductPage'), loading })
const TeamPage                        = Loadable({ loader: () => import('pages/TeamPage/TeamPage'), loading })
const CareersPage                     = Loadable({ loader: () => import('pages/CareersPage/CareersPage'), loading })
const PayPalLandingPage               = Loadable({ loader: () => import('pages/PayPalLandingPage/PayPalLandingPage'), loading })
const InvitePage                      = Loadable({ loader: () => import('pages/InvitePage/InvitePage'), loading })
const MainPage                        = Loadable({ loader: () => import('pages/MainPage/MainPage'), loading })
const SmartSearchPage                 = Loadable({ loader: () => import('pages/SmartSearchPage/SmartSearchPage'), loading })
const ExtrasPage                      = Loadable({ loader: () => import('pages/ExtrasPage/ExtrasPage'), loading })
const FragranceOfTheMonthListPage     = Loadable({ loader: () => import('pages/FragranceOfTheMonthListPage/FragranceOfTheMonthListPage'), loading })
const FragranceOfTheMonthPage         = Loadable({ loader: () => import('pages/FragranceOfTheMonthPage/FragranceOfTheMonthPage'), loading })
const OldFragranceOfTheMonthPage      = Loadable({ loader: () => import('pages/OldFragranceOfTheMonthPage/FragranceOfTheMonthPage'), loading })
const SuccessfulVerificationPage      = Loadable({ loader: () => import('pages/SuccessfulVerificationPage/SuccessfulVerificationPage'), loading })
const FacebookEmailRegistrationPage   = Loadable({ loader: () => import('pages/FacebookEmailRegistrationPage/FacebookEmailRegistrationPage'), loading })
const PressPage                       = Loadable({ loader: () => import('pages/PressPage/PressPage'), loading })
const CCPAPage                        = Loadable({ loader: () => import('pages/CCPAPage/CCPAPage'), loading })
const ScentbirdReviewsPage            = Loadable({ loader: () => import('pages/ScentbirdReviewsPage/ScentbirdReviewsPage'), loading })
const GiftCardTermsPage               = Loadable({ loader: () => import('pages/GiftCardTermsPage/GiftCardTermsPage'), loading })
const ClaimGiftCardPage               = Loadable({ loader: () => import('pages/ClaimGiftCardPage/ClaimGiftCardPage'), loading })
const CollectionLandingPage           = Loadable({ loader: () => import('pages/CollectionLandingPage/CollectionLandingPage'), loading })
const CollectionsPage                 = Loadable({ loader: () => import('pages/CollectionsPage/CollectionsPage'), loading })
const CollectionPage                  = Loadable({ loader: () => import('pages/CollectionPage/CollectionPage'), loading })
const CouponsPage                     = Loadable({ loader: () => import('pages/CouponsPage/CouponsPage'), loading })
const PopularInStatesPage             = Loadable({ loader: () => import('pages/PopularInStatesPage/PopularInStatesPage'), loading })
const RequestPage                     = Loadable({ loader: () => import('pages/RequestPage/RequestPage'), loading })
const TrackingPage                    = Loadable({ loader: () => import('pages/TrackingPage/TrackingPage'), loading })
const FragranceFinderPage             = Loadable({ loader: () => import('pages/FragranceFinderPage/FragranceFinderPage'), loading })
const QueuePage                       = Loadable({ loader: () => import('pages/QueuePage/QueuePage'), loading })
const FlashSaleBundlePage             = Loadable({ loader: () => import('pages/bundle/FlashSaleBundlePage/FlashSaleBundlePage'), loading })
const FathersDayGiftSetPage           = Loadable({ loader: () => import('pages/bundle/FathersDayGiftSetPage/FathersDayGiftSetPage'), loading })
const CaseSubscriptionPage            = Loadable({ loader: () => import('pages/CaseSubscriptionPage/CaseSubscriptionPage'), loading })
const MembershipPage                  = Loadable({ loader: () => import('pages/MembershipPage/MembershipPage'), loading })
const ImproveSurveyPage               = Loadable({ loader: () => import('pages/ImproveSurveyPage/ImproveSurveyPage'), loading })
const ImproveRecommendationsPage      = Loadable({ loader: () => import('pages/ImproveRecommendationsPage/ImproveRecommendationsPage'), loading })
const NoteProductsPage                = Loadable({ loader: () => import('pages/NoteProductsPage/NoteProductsPage'), loading })
const CollectionForSalePage           = Loadable({ loader: () => import('pages/CollectionForSalePage/CollectionForSalePage'), loading })
const CollectionsForSalePage          = Loadable({ loader: () => import('pages/CollectionsForSalePage/CollectionsForSalePage'), loading })
const NewArrivalsPage                 = Loadable({ loader: () => import('pages/NewArrivalsPage/NewArrivalsPage'), loading })

const EmailUnsubscribePage            = Loadable({ loader: () => import('pages/EmailUnsubscribePage/EmailUnsubscribePage'), loading })

// onboarding quiz
const QuizPage                        = Loadable({ loader: () => import('pages/QuizPage/QuizPage'), loading })
const QuizProductPage                 = Loadable({ loader: () => import('pages/QuizProductPage/QuizProductPage'), loading })
const QuizRecommendationsPage         = Loadable({ loader: () => import('pages/QuizRecommendationsPage/QuizRecommendationsPage'), loading })

// gifts
const GiftPage                        = Loadable({ loader: () => import('pages/GiftPage/GiftPage'), loading })
const GiftsPage                       = Loadable({ loader: () => import('pages/GiftsPage/GiftsPage'), loading })
const GiftCardPage                    = Loadable({ loader: () => import('pages/GiftCardPage/GiftCardPage'), loading })
const GiftSetsPage                    = Loadable({ loader: () => import('pages/giftSets/GiftSetsPage/GiftSetsPage'), loading })
const GiftSetPage                     = Loadable({ loader: () => import('pages/giftSets/GiftSetPage/GiftSetPage'), loading })

// horoscope
const HoroscopePage                   = Loadable({ loader: () => import('pages/horoscope/HoroscopePage/HoroscopePage'), loading })
const ZodiacSignPage                  = Loadable({ loader: () => import('pages/horoscope/ZodiacSignPage/ZodiacSignPage'), loading })

// auth
const LoginPage                       = Loadable({ loader: () => import('pages/auth/LoginPage/LoginPage'), loading })
const RegisterPage                    = Loadable({ loader: () => import('pages/auth/RegisterPage/RegisterPage'), loading })
const ResetPasswordPage               = Loadable({ loader: () => import('pages/auth/ResetPasswordPage/ResetPasswordPage'), loading })
const RemindPasswordPage              = Loadable({ loader: () => import('pages/auth/RemindPasswordPage/RemindPasswordPage'), loading })
const RecoverPasswordPage             = Loadable({ loader: () => import('pages/auth/RecoverPasswordPage/RecoverPasswordPage'), loading })

// search result
const SearchResultPage                = Loadable({ loader: () => import('pages/SearchResultPage/SearchResultPage'), loading })

// taste maker
const TasteMakerPage                  = Loadable({ loader: () => import('pages/TasteMakerPage/TasteMakerPage'), loading })

// recommendations
const RecommendationsLayout           = Loadable({ loader: () => import('pages/recommendations/RecommendationsLayout/RecommendationsLayout'), loading })
const RecommendationsPage             = Loadable({ loader: () => import('pages/recommendations/RecommendationsPage/RecommendationsPage'), loading })
const HistoryRecommendationsPage      = Loadable({ loader: () => import('pages/recommendations/HistoryRecommendationsPage/HistoryRecommendationsPage'), loading })
const RecommendationsQuizPage         = Loadable({ loader: () => import('pages/recommendations/RecommendationsQuizPage/RecommendationsQuizPage'), loading })
const NetflixRecommendations          = Loadable({ loader: () => import('pages/NetflixRecommendations/NetflixRecommendations'), loading })

// onboarding
const GetTheMostPage                  = Loadable({ loader: () => import('pages/GetTheMostPage/GetTheMostPage'), loading })

// incubator page
const IncubatorPage                   = Loadable({ loader: () => import('pages/IncubatorPage/IncubatorPage'), loading })
const FragranceConceptsPage           = Loadable({ loader: () => import('pages/FragranceConceptsPage/FragranceConceptsPage'), loading })
const IncubatorFragranticaSelectionsPage = Loadable({ loader: () => import('pages/incubator/FragranticaSelectionsPage/FragranticaSelectionsPage'), loading })

// Hackathon task
// const HowToChoose                     = Loadable({ loader: () => import('pages/HowToChoose/HowToChoose'), loading })


const SiteHealth                      = () => null

/**
 *
 * @param {Object} structure
 * @param {Function} renderCallback
 * @returns {*[]}
 */
const getCataloguePageRoutes = (structure, renderCallback) => {
  const routes = []

  const getRouteData = (items) => {
    items.forEach(({ children, ...item }) => {
      if (item.url) {
        routes.push({
          url: item.url,
          data: item,
        })
      }

      if (children) {
        getRouteData(children)
      }
    })
  }

  if (structure) {
    Object.values(structure).forEach((children) => getRouteData(children))
  }

  const result = []

  routes.forEach(({ url, data }) => {
    result.push(
      <Route
        key={`route-${data.id}`}
        path={url}
        exact
        render={renderCallback(data)}
      />,
      <Redirect
        key={`redirect-${data.id}`}
        exact
        from={`/catalogue/${data.id}`}
        to={url}
      />
    )
  })

  return result
}

const cosmeticsProductsPageRender = (data) => (props) => <CosmeticsProductsPage data={data} {...props} />
const newArrivalsPageRender       = (data) => (props) => <NewArrivalsPage data={data} {...props} />

const getLandingPageRoutes = () => {
  const layoutProps = {
    withBanner: false,
    withSubHeader: false,
    withSearchInput: false,
    withDiscountBanner: true,
  }

  const mixLinks = {
    women: links.newMix,
    men: links.newMixMale,
  }

  return (
    <Fragment>
      {/* ATTN don't use LandingLayout! It is deprecated! */}

      <Route path={links.homeTemp} exact component={RootPage} />
      <Route path={links.homeTempMen} exact component={RootPage} />
      <Route path={links.netflixRecommendations} exact component={NetflixRecommendations} />

      {/* Mix landings */}
      <LandingLayout {...{ ...layoutProps, links: mixLinks, headerColor: 'pink' }}>
        <Route path={links.newMix} exact component={NewFemaleMixPage} />
      </LandingLayout>
      <LandingLayout {...{ ...layoutProps, links: mixLinks, transparentView: true, whiteControls: true }}>
        <Route path={links.newMixMale} exact component={NewMaleMixPage} />
      </LandingLayout>
      <LandingLayout {...layoutProps}>
        <Route path={links.mix} exact component={MixPage} />
      </LandingLayout>

      {/* Free trial landings */}
      <Route path={links.freeTrial} exact component={FreeTrialPage} />
      <Route path={links.freeTrialMale} exact component={FreeTrialPage} />
      {/* men should be first */}
      <Route path={links.emailMen} exact component={EmailLandingPage} />
      <Route path={links.email} exact component={EmailLandingPage} />
      <Route path={links.emailQuizPick} exact component={EmailQuizPickPage} />

      {/* Other landings */}
      <Route path={links.referralLandingTemp} exact component={ReferralLandingPage} />
      <Route path={links.referralLanding} exact component={ReferralLandingPage} />

      <LandingLayout {...layoutProps}>
        <Route path={links.skincareIntro} exact component={SkincareIntroPage} />
      </LandingLayout>
      <LandingLayout {...{ ...layoutProps, withDiscountBanner: false }}>
        <Route path={links.popupShop} exact component={PopupShopPage} />
      </LandingLayout>
    </Fragment>
  )
}

const getRoutes = (props) => {
  const {
    paymentProvider,
    features,
    abTests,
    device,
    cookies,
    initialDevice = {},
    cosmeticsDataStructure: catalogueStructure,
  } = props

  const isRecurly = paymentProvider === 'RECURLY'

  const isMobile                              = initialDevice.isMobile || device.isMobile
  const isTossInEnabled                       = features[constants.features.tossIn]
  const isPasswordRestoreWithTokenEnabled     = features[constants.features.passwordRestoreWithToken]
  const isRecommendationsImproveEnabled       = features[constants.features.recommendationsImprove]
  const isUnpauseOffersEnabled                = features[constants.features.unpauseOffers]
  const isNotesProductPageEnabled             = features[constants.features.productsBasedOnNotes]
  const isCollectionForSalePageEnabled        = features[constants.features.collectionsForSale]
  const isGiftsHidden                         = features[constants.features.hideGifts]
  const isTasteMakersLandingPageEnabled       = features[constants.features.tasteMakersLanding]
  const isBrandPageEnabled                    = features[constants.features.brandPage]
  const isInvitePageMobileEnabled             = isMobile
  const isResubscribe50offAbEnabled           = getAbValue(constants.abTests.resubscribe50off, abTests) === 'b'
  const isCardUpdatePageAbEnabled             = getAbValue(constants.abTests.cardUpdate, abTests) === 'b' || isRecurly
  const isNewPOMEnabled                       = features[constants.features.pom]
  const isRetailValue150Enabled               = features[constants.features.retailValue150Filter]

  const { newArrivals, ...cosmeticsDataStructure } = catalogueStructure || {}

  const cosmeticsProductsPageRoutes = getCataloguePageRoutes(cosmeticsDataStructure, cosmeticsProductsPageRender)
  const newArrivalsPageRoutes       = newArrivals ? getCataloguePageRoutes({ newArrivals }, newArrivalsPageRender) : []

  const SubscribePage               = isRecurly ? RecurlySubscribePage : OldSubscribePage
  const EcommercePage               = isRecurly ? RecurlyEcommercePage : OldPaymentPage
  const GiftCardPaymentPage         = isRecurly ? RecurlyGiftCardPaymentPage : OldGiftCardPaymentPage
  const GiftSubscriptionPaymentPage = isRecurly ? RecurlyGiftSubscriptionPaymentPage : OldGiftSubscriptionPaymentPage
  const GiftSubscriptionRedeemPage  = isRecurly ? RecurlyGiftSubscriptionRedeemPage : OldGiftSubscriptionRedeemPage
  const RedeemCouponPage            = isRecurly ? RecurlyRedeemCouponPage : OldRedeemCouponPage
  const ThankYouPage                = isRecurly ? RecurlyThankYouPage : OldThankYouPage
  const BuyQueuePage                = isRecurly ? RecurlyBuyQueuePage : OldBuyQueuePage
  const RedeemQueuePage             = isRecurly ? RecurlyRedeemQueuePage : OldRedeemQueuePage
  const NewCardUpdatePage           = isRecurly ? RecurlyCardUpdatePage : CardUpdatePageNew

  return (
    <App>
      <Switch>

        <Route path="/with-mirage" component={WithMiragePage} />
        <Route path="/site-health" component={SiteHealth} />
        <Route path="/check-helmet" component={CheckHelmet} />
        {/* <Route path="/how-to-choose" component={HowToChoose} /> */}


        {/* ---------------------------------------     NO AUTH     --------------------------------------- */}


        {/* https://scentbird.atlassian.net/browse/SB-2200 */}
        <Redirect exact from="/case" to={links.caseSubscription} />
        <Redirect exact from="/case-monthly" to={links.caseSubscription} />

        <Redirect exact from="/upgrade-3" to={links.upgradeProduct} />
        <Redirect exact from="/upgrade-6" to={links.upgradeProduct} />
        <Redirect exact from="/upgrade-12" to={links.upgradeProduct} />
        <Redirect exact from="/upgrade-plan" to={links.upgradeProduct} />
        <Redirect exact from="/prepaid-plans" to={links.upgradeProduct} />

        <Redirect exact from={links.subscription.root} to={links.subscription.mainWomen} />
        <Redirect exact from={links.userProfile.root} to={links.userProfile.receivedProducts} />

        <Redirect exact from={links.profile.root} to={links.profile.subscriptionStatus} />
        {/* /!* TODO move this redirect to nginx *!/ */}
        <Redirect exact from="/profile/rated-fragrances" to={links.profile.ratedProducts} />
        {/* /!* TODO move this redirect to nginx *!/ */}
        <Redirect exact from="/profile/fragrances-in-queue" to={links.queue} />

        {/* TODO: for temporary redirects! SCNT-4477 */}
        <Redirect exact from="/lip-balms" to={links.bodyLip} />
        <Redirect exact from="/scrub/:slug" to={links.productPageBody} />
        <Redirect exact from="/scrubs/:slug" to={links.productPageBody} />
        <Redirect exact from="/lip-balm/:slug" to={links.productPageBodyLip} />
        <Redirect exact from="/lip-balms/:slug" to={links.productPageBodyLip} />

        {/* NO Header, NO Footer */}

        <Redirect exact from={links.welcome} to={links.pick} />
        <Route path={links.pick} exact component={PickPage} />
        <Route path={links.request} exact component={RequestPage} />
        <Route path={links.plan} exact component={PlanPage} />
        <Route path={links.collectionLanding} exact component={CollectionLandingPage} />

        {/* NO Footer */}

        <WithoutHeaderLayout withFooter={false}>
          <Route path={links.successfulEmailVerification} exact component={SuccessfulVerificationPage} />
          <Route path={links.claimGiftCard} exact component={ClaimGiftCardPage} />
        </WithoutHeaderLayout>

        {/* NO Header */}

        {/* Quiz */}
        <Route path={links.choose} exact component={QuizPage} />

        <HumbleLayout withFooter>
          <Route path={links.quiz} exact component={QuizPage} />
          <Route path={links.quizMen} exact component={QuizPage} />
        </HumbleLayout>

        {/* Payment */}
        <Route path={links.subscribe} exact component={SubscribePage} />
        <Route path={links.giftCardPayment} exact component={GiftCardPaymentPage} />
        <Route path={links.giftSubscriptionPayment} exact component={GiftSubscriptionPaymentPage} />
        <Route path={links.giftRedeem} exact component={GiftSubscriptionRedeemPage} />
        <Route path={links.couponPayment} exact component={RedeemCouponPage} />
        <HasAuth>
          <Route path={links.checkout} exact component={EcommercePage} />
          <Route path={links.thankYou} exact component={ThankYouPage} />
        </HasAuth>
        <Route path={links.recurlyThankYou} exact component={ThankYouPage} />

        {/* New Payment */}
        <Route path={links.subscribeNew} exact component={SubscribePrototypePage} />
        <Route path={links.queueRedeem} exact component={RedeemQueuePage} />
        <Route path={links.tossInRedeem} exact component={RedeemTossInPage} />

        {/* NO HeaderBanner, NO SubHeader, NO SearchInput */}

        {getLandingPageRoutes()}

        {/* Resubscribe landings */}
        <Route path={links.resubscribeNoOffer} exact component={MultiOfferResubscribePage} />
        <Route path={links.casePrize} exact component={MultiOfferResubscribePage} />
        <Route path={links.resubscribe} exact component={MultiOfferResubscribePage} />
        <Route path={links.resubscribeFree} exact component={MultiOfferResubscribePage} />

        <Route path={links.resubscribeFreeProduct} exact component={ResubscribeFreeProductPage} />
        {
          isResubscribe50offAbEnabled && (
            <Route path={links.resubscribe50} exact component={Resubscribe50Page} />
          )
        }

        {/* Register and login */}
        <Route path={links.register} exact component={RegisterPage} />
        <Route path={links.login} exact component={LoginPage} />
        <Route path={links.remindPassword} exact component={RemindPasswordPage} />
        <Route path={links.recoverPassword} exact component={RecoverPasswordPage} />

        {/* NO Header, Link logo */}

        <WithoutHeaderLayout withFooter logoLink={links.home}>
          {
            isPasswordRestoreWithTokenEnabled && (
              <Route path={links.resetPassword} exact component={ResetPasswordPage} />
            )
          }
          <Route path={links.facebookEmailRegistration} exact component={FacebookEmailRegistrationPage} />
        </WithoutHeaderLayout>

        {/* WITH HeaderBanner, NO SubHeader */}

        <InsideLayout withSubHeader={false} withBanner>
          <Route path={links.team} exact component={TeamPage} />
          <Route path={links.careers} exact component={CareersPage} />
          <Route path={links.howHandCreamsWork} exact component={HowHandCreamsWorkPage} />
          <Route path={links.howItWorks} exact component={HowItWorksPage} />
          <Route path={links.scentbirdReviews} exact component={ScentbirdReviewsPage} />
          <HasAuth>
            <Route path={links.payPalUpdate} exact component={PayPalLandingPage} />
          </HasAuth>
        </InsideLayout>

        {/* NO HeaderBanner, NO SubHeader */}

        <InsideLayout withSubHeader={false} withBanner={false}>
          <Route path={links.gift} exact component={GiftPage} />
          <Route path={links.giftFb} exact component={GiftPage} />
          <Route path={links.gifts} exact component={GiftsPage} />
          <Route path={links.giftCard} exact component={GiftCardPage} />
          <Route path={links.giftCardTerms} exact component={GiftCardTermsPage} />
          <Route path={links.press} exact component={PressPage} />
          <Route path={links.ccpa} exact component={CCPAPage} />

          <Route path={links.resub} exact component={ResubscribeOldPage} />
          <Route path={links.resubscribe3} exact component={ResubscribeOldPage} />
          <Route path={links.resubscribe5} exact component={ResubscribeOldPage} />
          <Route path={links.resubscribe5mo12} exact component={ResubscribeOldPage} />
          {
            !isResubscribe50offAbEnabled && (
              <Route path={links.resubscribe50} exact component={ResubscribeOldPage} />
            )
          }
          {
            isUnpauseOffersEnabled && (
              <Fragment>
                <Route path={links.unpause} exact component={UnpausePage} />
                <Route path={links.unpause50} exact component={UnpausePage} />
              </Fragment>
            )
          }
        </InsideLayout>

        {/* WITH SubHeader */}

        <InsideLayout withSubHeader>
          {
            isBrandPageEnabled && (
              <Fragment>
                <Route path={links.brand} exact component={BrandPage} />
                <Route path={links.brands} exact component={BrandsPage} />
              </Fragment>
            )
          }

          <Route path={links.unsubscribe} exact component={EmailUnsubscribePage} />
          <Route path={links.blogger} exact component={BloggerPage} />
          {
            isGiftsHidden ? (
              <Fragment>
                <Redirect exact from={links.giftSet} to={links.gifts} />
                <Redirect exact from={links.giftSetsMen} to={links.gifts} />
              </Fragment>
            ) : (
              <Fragment>
                <Route path={links.giftSet} exact component={GiftSetsPage} />
                <Route path={links.giftSetsMen} exact component={GiftSetsPage} />
              </Fragment>
            )
          }
          <Route path={links.newGiftSet} exact component={GiftSetPage} />
          <Route path={links.skincareSets} exact component={GiftSetsPage} />
          <Route path={links.skincareSet} exact component={GiftSetPage} />
          <Route path={links.coupons} exact component={CouponsPage} />
          {
            isTasteMakersLandingPageEnabled && (
              <Fragment>
                <Route path={links.tasteMakers} exact component={TasteMakerPage} />
                <Route path={links.tasteMakersMen} exact component={TasteMakerPage} />
              </Fragment>
            )
          }

          { /* POM */ }
          {
            isNewPOMEnabled && (
              <Fragment>
                <Route path={links.subscription.perfumeOfTheMonthList} exact component={FragranceOfTheMonthListPage} />
                <Route path={links.subscription.cologneOfTheMonthList} exact component={FragranceOfTheMonthListPage} />
                <Route path={[ links.subscription.perfumeOfTheMonth, links.subscription.currPerfumeOfTheMonth ]} exact component={FragranceOfTheMonthPage} />
                <Route path={[ links.subscription.cologneOfTheMonth, links.subscription.currCologneOfTheMonth ]} exact component={FragranceOfTheMonthPage} />
              </Fragment>
            )
          }

          { /* Catalogue: New Arrivals */ }

          <Fragment>
            {newArrivalsPageRoutes}
          </Fragment>
        </InsideLayout>

        {/* WITH Queue */}

        <InsideLayout withSubHeader>
          <SubscriptionLayout>
            <Route path={links.subscription.mainMen} exact component={MainPage} />
            <Route path={links.subscription.mainWomen} exact component={MainPage} />
            <Redirect exact from="/subscription/main-women-empty" to={links.subscription.mainWomen} />
            <Redirect exact from="/subscription/main-men-empty" to={links.subscription.mainMen} />
            {
              !isBrandPageEnabled && (
                <Route path={links.brand} exact component={BrandPageOld} />
              )
            }
            <Route path={links.subscription.collectionsWomen} exact component={CollectionsPage} />
            <Route path={links.subscription.collectionsMen} exact component={CollectionsPage} />
            <Route path={links.productTypeCollectionMenNew} exact component={CollectionsPage} />
            <Route path={links.productTypeCollectionWomenNew} exact component={CollectionsPage} />
            <Redirect exact from={links.productTypeCollectionMen} to={links.productTypeCollectionMenNew} />
            <Redirect exact from={links.productTypeCollectionWomen} to={links.productTypeCollectionWomenNew} />
            <Route path={links.collection} exact component={CollectionPage} />
            <Route path={links.collectionMen} exact component={CollectionPage} />
            <Route path={links.collectionWomen} exact component={CollectionPage} />
            <Route path={links.skincareCollectionItemWomenNew} exact component={CollectionPage} />
            <Route path={links.skincareCollectionItemMenNew} exact component={CollectionPage} />
            <Route path={links.popularInStates} exact component={PopularInStatesPage} />

            {
              !isNewPOMEnabled && (
                <Fragment>
                  <Route path={[ links.subscription.perfumeOfTheMonth, links.subscription.currPerfumeOfTheMonth ]} exact component={OldFragranceOfTheMonthPage} />
                  <Route path={[ links.subscription.cologneOfTheMonth, links.subscription.currCologneOfTheMonth ]} exact component={OldFragranceOfTheMonthPage} />
                </Fragment>
              )
            }

            { /* Catalogue: Makeup, Skincare, Wellness, Personal Care */ }

            <Fragment>
              {cosmeticsProductsPageRoutes}
            </Fragment>

            <Route path={links.candles} exact component={ProductsPage} />
            <Route path={links.newProducts} exact component={ProductsPage} />
            <Route path={links.makeupBrand} exact component={ProductsPage} />
            <Route path={links.bestsellersMen} exact component={ProductsPage} />
            <Route path={links.bestsellersWomen} exact component={ProductsPage} />
            <Route path={links.scentbirdProducts} exact component={ProductsPage} />
            <Route path={links.fragranceFinder} exact component={FragranceFinderPage} />
          </SubscriptionLayout>
        </InsideLayout>

        {/* Product page */}

        <Route path={links.productPageCommonProduct} exact component={ProductPage} isProduct />
        <Route path={links.productPagePerfumes} exact component={ProductPage} isProduct />
        <Route path={links.productPagePerfume} exact component={ProductPage} isProduct />
        <Route path={links.productPageHandCreams} exact component={ProductPage} isProduct />
        <Route path={links.productPageHandCream} exact component={ProductPage} isProduct />
        <Route path={links.productPageBodyLip} exact component={ProductPage} isProduct />
        <Route path={links.productPageBody} exact component={ProductPage} isProduct />
        <Route path={links.productPageShowerGels} exact component={ProductPage} isProduct />
        <Route path={links.productPageShowerGel} exact component={ProductPage} isProduct />
        <Route path={links.productPageCandles} exact component={ProductPage} isProduct />
        <Route path={links.productPageCandle} exact component={ProductPage} isProduct />
        <Route path={links.productMakeup} exact component={ProductPage} isProduct />
        <Route path={links.productPersonalCare} exact component={ProductPage} isProduct />
        <Route path={links.productExtra} exact component={ProductPage} isProduct />
        <Route path={links.productExtras} exact component={ProductPage} isProduct />
        <Route path={links.productSkincare} exact component={ProductPage} isProduct />
        <Route path={links.productWellness} exact component={ProductPage} isProduct />
        <Route path={links.productLanding} exact component={ProductPage} isProduct />

        {/* Horoscope */}

        <InsideLayout withBreadcrumbs>
          <Route path={links.zodiacSign} exact component={ZodiacSignPage} />
          <Route path={links.horoscope} exact component={HoroscopePage} />
        </InsideLayout>

        {/* User Profile */}

        <InsideLayout withSubHeader>
          <UserProfileLayout>
            <Route path={links.userProfile.receivedProducts} exact component={ReceivedProductsPage} />
            <Route path={links.userProfile.productsInQueue} exact component={ProductsInQueuePage} />
            <Route path={links.userProfile.ratedProducts} exact component={UserProfileRatedProductsPage} />
            <Route path={links.userProfile.reviews} exact component={UserProfileReviewsPage} />
          </UserProfileLayout>
        </InsideLayout>


        {/* ---------------------------------------     HAS AUTH     --------------------------------------- */}


        {/* NO HEADER NO FOOTER */}

        <HasAuth>

          <Route path={links.membership} exact component={MembershipPage} />
          <Route path={links.cancelSubscription} exact component={CancelSubscriptionPage} />

          <Redirect exact from={links.fInvite} to={links.invite} />
          <Redirect exact from={links.mInvite} to={links.invite} />

          {
            isInvitePageMobileEnabled && (
              <Route path={links.invite} exact component={InvitePage} />
            )
          }

          {/* NO HEADER */}

          <WithoutHeaderLayout withFooter>
            <Route path={links.quizProduct} exact component={QuizProductPage} />
            <Route path={links.incubator.fragranceConcepts} exact component={FragranceConceptsPage} />
            <Route path={links.improveSurvey} exact component={ImproveSurveyPage} />
          </WithoutHeaderLayout>

          {
            isRecommendationsImproveEnabled && (
              <WithoutHeaderLayout withFooter logoCenter>
                <Route path={links.improveRecommendations} exact component={ImproveRecommendationsPage} />
              </WithoutHeaderLayout>
            )
          }

          {/* WITH SubHeader, NO HeaderBanner */}

          <InsideLayout withSubHeader withBanner={false} withSearchInput={false}>
            <Route path={links.incubator.neonHeat} exact component={IncubatorPage} />
            <Route path={links.buyQueue} exact component={BuyQueuePage} />
          </InsideLayout>

          {/* WITH SubHeader */}


          {
            isCardUpdatePageAbEnabled && (
              <Fragment>
                <Route path={links.cardUpdate} exact component={NewCardUpdatePage} />
                <Route path={links.cardUpdate50} exact component={NewCardUpdatePage} />
                <Route path={links.caseCardUpdate} exact component={NewCardUpdatePage} />
              </Fragment>
            )
          }

          <Route path={links.cardUpdateFreePerfume} exact component={NewCardUpdatePage} />

          <InsideLayout withSubHeader>
            {
              !isCardUpdatePageAbEnabled && (
                <Fragment>
                  <Route path={links.cardUpdate} exact component={CardUpdatePage} />
                  <Route path={links.cardUpdate50} exact component={CardUpdatePage} />
                  <Route path={links.caseCardUpdate} exact component={CaseCardUpdatePage} />
                </Fragment>
              )
            }
            <Route path={links.downgrade} exact component={DowngradePage} />
            <Route path={links.upgrade} exact component={UpgradePage} />
            <Route path={links.upgradeProduct} exact component={UpgradeProductPage} />
            {/* <Route path={links.thankYou} exact component={ThankYouPage} /> */}
            {
              !isInvitePageMobileEnabled && (
                <Route path={links.invite} exact component={InvitePage} />
              )
            }
            <Route path={links.searchResult} exact component={SearchResultPage} />
            {
              isTossInEnabled && (
                <Route path={links.tossIn} exact component={TossInPage} />
              )
            }
            <Route path={links.tracking} exact component={TrackingPage} />
            <Route path={links.queue} exact component={QueuePage} />
            <Route path={links.incubator.fragranticaSelections.root} component={IncubatorFragranticaSelectionsPage} />
            <Route path={links.flashSale} exact component={FlashSaleBundlePage} />
            <Route path={links.caseSubscription} exact component={CaseSubscriptionPage} />
            <Route path={links.fathersDayGiftSet} exact component={FathersDayGiftSetPage} />
            {
              isNotesProductPageEnabled && (
                <Fragment>
                  <Route path={links.noteWomen} exact component={NoteProductsPage} />
                  <Route path={links.noteMen} exact component={NoteProductsPage} />
                </Fragment>
              )
            }
            {
              isCollectionForSalePageEnabled && (
                <Fragment>
                  <Route path={links.collectionsForSale} exact component={CollectionsForSalePage} />
                  <Route path={links.collectionForSale} exact component={CollectionForSalePage} />
                </Fragment>
              )
            }
            <RecommendationsLayout>
              <Route path={links.recommendations.root} exact component={RecommendationsPage} />
              <Route path={links.recommendations.history} exact component={HistoryRecommendationsPage} />
              <Route path={links.recommendations.quiz} exact component={RecommendationsQuizPage} />
              {/* <Route path={links.recommendations.selections} exact component={HistoryRecommendationsPage} /> */}
            </RecommendationsLayout>
            <Route path={links.getTheMost} exact component={GetTheMostPage} />
          </InsideLayout>

          {/* WITH Queue */}

          <InsideLayout withSubHeader>
            <SubscriptionLayout>
              <Route path={links.subscription.smartSearch} exact component={SmartSearchPage} />
              <Route path={links.subscription.perfumes} exact component={SmartSearchPage} />
              <Route path={links.subscription.colognes} exact component={SmartSearchPage} />
              <Route path={links.subscription.newArrivals} exact component={SmartSearchPage} />
              <Route path={links.subscription.bestsellers} exact component={SmartSearchPage} />
              <Route path={links.subscription.bestsellersAll} exact component={SmartSearchPage} />
              <Route path={links.subscription.extras} exact component={ExtrasPage} />

              {
                isRetailValue150Enabled ? (
                  <Route path={links.subscription.retailValue150} exact component={SmartSearchPage} />
                ) : (
                  <Redirect from={links.subscription.retailValue150} exact to={links.subscription.smartSearch} />
                )
              }

              <Redirect exact from={links.subscription.featured} to={links.subscription.mainWomen} />
            </SubscriptionLayout>
          </InsideLayout>

          <HumbleLayout>
            <Route path={links.subscription.recommendations} exact component={QuizRecommendationsPage} />
          </HumbleLayout>

          <InsideLayout withSubHeader>
            {/* My Profile */}
            <ProfileLayout>
              <Route path={links.profile.subscriptionStatus} exact component={SubscriptionStatusPage} />
              <Route path={links.profile.orderHistory} exact component={OrderHistoryPagePage} />
              <Route path={links.profile.ecommerceOrder} exact component={EcommerceOrderPage} />
              <Route path={links.profile.changePassword} exact component={ChangePasswordPage} />
              <Route path={links.profile.personal} exact component={PersonalPage} />
              <Route path={links.profile.billingAndShipping} exact component={BillingAndShippingPage} />
              <Route path={links.profile.sentGifts} exact component={SentGiftsPage} />
              <Route path={links.profile.reviews} exact component={ReviewsPage} />
              <Route path={links.profile.ratedProducts} exact component={RatedProductsPage} />
              {/* Redirect from old order pages */}
              <Redirect exact from={links.profile.upgradeSubscription} to={links.profile.subscriptionStatus} />
              <Redirect exact from={links.profile.orders} to={links.profile.orderHistory} />
              <Redirect exact from={links.profile.order} to={links.profile.ecommerceOrder} />
              <Redirect exact from={links.profile.ordersStatus} to={links.profile.orderHistory} />
            </ProfileLayout>
          </InsideLayout>

        </HasAuth>
        {
          process.env.WEBPACK === 'dev' && (
            <Route path="/404" exact component={Page404} />
          )
        }
        <Route path="*" component={NoMatch} />

      </Switch>
    </App>
  )
}


export default getRoutes
